<template>
  <div :class="$style.container">
    <div :class="$style.logo">
      <logo-large />
    </div>
  </div>
</template>

<script>
import LogoLarge from 'atoms/logos/LogoLarge';

export default {
  name: 'LoginPoster',
  components: {
    LogoLarge,
  },
};
</script>

<style lang="sass" module>
  .container
    display: flex
    flex-direction: column

  .logo
    max-width: 300px
    margin-right: 80px
    display: flex

    svg
      width: 100%
      height: 100%
</style>
